/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AverageBuildTimeDto, AverageBuildTimeValue } from '@gh/builder-shared-data';
import { IS_REGION_AU_OR_NZ } from '@gh/common-shared';
import { isNull } from 'lodash';

export type AverageBuildTime = AverageBuildTimeDto;
export type AverageBuildTimeItem = {
  [index: string]: any;
};

export const averageBuildTimeRowKey: string = IS_REGION_AU_OR_NZ ? 'lbl_floor_area_m2' : 'lbl_floor_area_ft2';

/** Unique key per row so ag-grid getRowId can distinguish rows (avoids duplicate row display) */
export const averageBuildTimeRowIdKey = '_rowId';

export const averageBuildTimeFromDto = (dto: AverageBuildTimeDto): AverageBuildTimeItem[] => {
  const items: AverageBuildTimeItem[] = [];
  const rowLabels: string[] = [
    IS_REGION_AU_OR_NZ ? '0-100' : '0-1000',
    IS_REGION_AU_OR_NZ ? '101-200' : '1001-2000',
    IS_REGION_AU_OR_NZ ? '201-300' : '2001-3000',
    IS_REGION_AU_OR_NZ ? '301+' : '3001+',
  ];

  dto.values.forEach((value: AverageBuildTimeValue, valueIndex: number) => {
    const values: AverageBuildTimeItem = {};
    values[averageBuildTimeRowIdKey] = valueIndex;
    dto.headerValues
      .forEach((headerValue: string, headerIndex: number) => {
        const weeksCount = value.values[headerIndex];
        const label = !isNull(weeksCount) ? 1 === weeksCount ? 'lbl_week_cnt' : 'lbl_weeks_cnt' : '-';

        values[averageBuildTimeRowKey] = rowLabels[valueIndex];
        values[headerValue] = {
          label,
          value: {
            count: weeksCount,
          },
        };
      });

    if (dto.headerValues.length > 0) {
      items.push(values);
    }
  });

  return items;
};
